import { render, staticRenderFns } from "./social.vue?vue&type=template&id=238d6c41&"
import script from "./social.vue?vue&type=script&lang=ts&"
export * from "./social.vue?vue&type=script&lang=ts&"
import style0 from "./social.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports